import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-454">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-455">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-456">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-457">
          {isOpen ? <XIcon size={24} data-id="element-458" /> : <PlusIcon size={24} data-id="element-459" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-460">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-461">
          {answer}
        </p>
      </div>
    </div>;
}
export function CBFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Is Clear + Brilliant Touch?',
    answer: 'Clear + Brilliant Touch is an advanced laser treatment that utilizes fractional laser technology to rejuvenate the skin, improve texture, and reduce signs of aging and sun damage.'
  }, {
    question: 'What Happens During A Session?',
    answer: 'During the treatment, patients may feel a sensation of heat and slight discomfort, but topical anesthetic is applied to ensure comfort. The procedure typically takes about 30-45 minutes, and a series of sessions are scheduled for optimal results.'
  }, {
    question: 'What Can I Expect After Treatment?',
    answer: 'Patients can typically resume their daily activities immediately following the treatment, although some redness and swelling may occur temporarily. Noticeable improvement in skin texture and tone can be seen after a single session, with full results achieved after a series of treatments.'
  }, {
    question: 'Are There Side Effects From This Laser Treatment?',
    answer: "Side effects are minimal and rare when performed by experienced professionals. Temporary redness and swelling may occur, but these typically resolve within a few hours. As with any laser treatment, it's essential to follow post-procedure care instructions provided by your provider."
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-462">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-463">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-464">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-465">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-466"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-467">
          <div className="space-y-2" data-id="element-468">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-469" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}